import card from './Card'
import modal from './Modal'
import customToggle from './CustomToggle'
import slider from './Slider'
import itemSlider from './ItemSlider'
import itemDoubleSlider from './ItemDoubleSlider'
import modalDelete from './ModalDelete'
import sliderImages from './SliderImages'
import floatButtons from './FloatButtons'
import notificacion from './Notificacion'
import audioApp from './AudioApp'
import folder from './Folder'
import fileItem from './FileItem'
import symbolIcon from './SymbolIcon'
import folderStatic from './FolderStatic'
import singleTagify from './SingleTagify'
import Tag from './Tag'
import ChecadorButton from './ChecadorButton'
import ModalSendMail from './ModalSendMail'

export const Card = card;
export const Modal = modal;
export const CustomToggle = customToggle;
export const Slider = slider;
export const ItemSlider = itemSlider;
export const ModalDelete = modalDelete;
export const SliderImages = sliderImages
export const FloatButtons = floatButtons
export const Notificacion = notificacion
export const AudioApp = audioApp
export const Folder = folder
export const FileItem = fileItem
export const SymbolIcon = symbolIcon
export const FolderStatic = folderStatic
export const ItemDoubleSlider = itemDoubleSlider
export const SingleTagify = singleTagify

export { Tag, ChecadorButton, ModalSendMail }